// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"153":"23d97f68","277":"a5e6c44d","734":"21d78121"}[chunkId] + ".chunk.js";
};